import { Link } from "react-router-dom";
import { SITE, WHATSAPP_LINK } from "../data/siteConfig";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="rs-footer" data-testid="main-footer">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <div className="d-flex align-items-center gap-2 mb-3">
              <span className="rs-brand-mark">RS</span>
              <div>
                <h6 className="mb-0">{SITE.brand}</h6>
                <small style={{ color: "rgba(255,255,255,0.55)" }}>
                  Advisory · Compliance · Training
                </small>
              </div>
            </div>
            <p>
              A professional legal and compliance consulting firm specializing
              in POSH compliance, corporate governance, and regulatory
              advisory — helping organizations build safe, inclusive and legally
              compliant workplaces.
            </p>
          </div>

          <div className="col-lg-2 col-md-6 col-6">
            <h6>Company</h6>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 col-6">
            <h6>Services</h6>
            <ul>
              <li><Link to="/services">POSH Training</Link></li>
              <li><Link to="/services">IC Advisory</Link></li>
              <li><Link to="/services">Policy Drafting</Link></li>
              <li><Link to="/services">Compliance & Filings</Link></li>
              <li><Link to="/services">Legal Advisory</Link></li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6>Get in Touch</h6>
            <ul>
              <li>
                <i className="bi bi-telephone-fill"></i>
                <a href={SITE.phoneHref}>{SITE.phone}</a>
              </li>
              <li>
                <i className="bi bi-envelope-fill"></i>
                <a href={SITE.emailHref}>{SITE.email}</a>
              </li>
              <li>
                <i className="bi bi-whatsapp"></i>
                <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer">
                  Chat on WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="rs-footer-bottom">
          © {year} {SITE.brand}. All rights reserved. ·
          <span> Built with care for safer workplaces.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
